import React, { FC } from 'react'
import InfoBlock from './InfoBlock'
import parse from 'html-react-parser'

interface Props {
  content: string
  error: string
  modifierClass?: string
  name: string
  setValue: (value: boolean) => void
  title: string
  touched: boolean
  value: boolean
  infoContent?: string
}

export const Checkbox: FC<Props> = ({
  content,
  error,
  modifierClass,
  name,
  setValue,
  title,
  touched,
  value,
  infoContent,
}) => {
  if (!content.length) {
    return null
  }

  const showError = error && touched
  const errorClass = showError ? '--error' : ''
  const checkedClass = value ? '--checked' : ''

  const handleCheckboxClick = () => {
    setValue(!value)
  }

  const handleKeyPress = (event): void => {
    if (['Enter', ' '].includes(event.key)) {
      setValue(!value)
    }
  }

  return (
    <div
      className={`checkbox__wrapper ${modifierClass || ''} ${errorClass || ''}`}
      data-testid={`checkbox-${name}`}
    >
      {title ? <h3 className="checkbox__title">{title}</h3> : null}
      <div className={`checkbox ${checkedClass || ''}`}>
        <div
          className="checkbox__checkbox"
          onClick={handleCheckboxClick}
          onKeyUp={handleKeyPress}
          tabIndex={0}
          role="checkbox"
          aria-checked={value}
        >
          <img
            className="checkbox__check-mark"
            src="/assets/check-mark.svg"
            alt="Check mark icon"
          />
        </div>
        <div className="checkbox__label" onClick={handleCheckboxClick}>
          {parse(content)}
        </div>
      </div>
      {!infoContent || (touched && error) ? null : (
        <InfoBlock>{infoContent}</InfoBlock>
      )}
      {showError ? <InfoBlock type="danger">{error}</InfoBlock> : null}
    </div>
  )
}

export default Checkbox
